// Official Rapid24News brand + contact + social constants (single source of truth)
export const BRAND = {
  name: "Rapid24News",
  tagline: "Fast • Trusted • Fearless",
  email: "rapid24news.in@gmail.com",
  location: "Lucknow, Uttar Pradesh, India",
  url: "https://rapid24news.in",
  founder: "Shivam Dubey",
};

export const SOCIAL = {
  youtube: { url: "https://www.youtube.com/@Rapid24News-j2u", label: "Rapid24News Official YouTube Channel" },
  instagram: { url: "https://www.instagram.com/r24n.digital", label: "Rapid24News Official Instagram Account" },
};

export const MAILTO = `mailto:${BRAND.email}`;
export const EMAIL_LABEL = "Email Rapid24News";
